module.exports = __webpack_public_path__ + "static/media/lifei.9f566d4f.png";